<template>
    <div class="cost-management">
        <el-card shadow="hover" style="margin-bottom: 20px;">
            <!-- <el-button type="primary" @click="handleAddCost">新增成本</el-button> -->
        </el-card>
        <el-table :data="costList" border style="width: 100%">
            <el-table-column prop="index" label="序号" width="80">
                <template #default="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="costName" label="成本名称"></el-table-column>
            <el-table-column prop="costType" label="成本类型"></el-table-column>
            <el-table-column prop="costUnit" label="成本单位"></el-table-column>
            <el-table-column prop="price" label="价格"></el-table-column>
            <el-table-column prop="timePeriod" label="时间段"></el-table-column>
            <!-- <el-table-column label="操作" width="120">
                <template #default="scope">
                    <el-button type="warning" size="small" @click="handleViewDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <!-- 新增成本对话框 -->
        <el-dialog title="新增成本" v-model="dialogVisible" width="50%">
            <el-form :model="newCost" label-width="120px">
                <el-form-item label="成本名称">
                    <el-input v-model="newCost.costName"></el-input>
                </el-form-item>
                <el-form-item label="成本类型">
                    <el-select v-model="newCost.costType">
                        <el-option label="电费" value="电费"></el-option>
                        <el-option label="水费" value="水费"></el-option>
                        <el-option label="燃气费" value="燃气费"></el-option>
                        <el-option label="人工" value="人工"></el-option>
                        <el-option label="其他成本" value="其他成本"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="成本单位">
                    <el-input v-model="newCost.costUnit"></el-input>
                </el-form-item>
                <el-form-item label="价格">
                    <el-input v-model.number="newCost.price"></el-input>
                </el-form-item>
                <el-form-item label="时间段">
                    <el-input v-model="newCost.timePeriod"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="handleConfirmAdd">确定</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 详情对话框 -->
        <el-dialog title="成本详情" v-model="detailDialogVisible" width="50%">
            <el-form :model="currentDetail" label-width="120px">
                <el-form-item label="成本名称">{{ currentDetail.costName }}</el-form-item>
                <el-form-item label="成本类型">{{ currentDetail.costType }}</el-form-item>
                <el-form-item label="成本单位">{{ currentDetail.costUnit }}</el-form-item>
                <el-form-item label="价格">{{ currentDetail.price }}</el-form-item>
                <el-form-item label="时间段">{{ currentDetail.timePeriod }}</el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="detailDialogVisible = false">关闭</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'CostManagement',
    data() {
        return {
            costList: [
                {
                    costName: '电费(高峰)',
                    costType: '电费',
                    costUnit: '元/度',
                    price: 0.8,
                    timePeriod: '17:00:00-22:00:00'
                },
                {
                    costName: '电费(全部)',
                    costType: '电费',
                    costUnit: '元/度',
                    price: 0.5,
                    timePeriod: '00:00:00-23:59:59'
                },
                {
                    costName: '水费',
                    costType: '水费',
                    costUnit: '元/方',
                    price: 0.4,
                    timePeriod: '00:00:00-23:59:59'
                },
                {
                    costName: '燃气费',
                    costType: '燃气费',
                    costUnit: '元/方',
                    price: 0.4,
                    timePeriod: '00:00:00-23:59:59'
                },
                {
                    costName: '人工',
                    costType: '人工',
                    costUnit: '',
                    price: 0.5,
                    timePeriod: '00:00:00-23:59:59'
                },
                {
                    costName: '其他',
                    costType: '其他成本',
                    costUnit: '元/天',
                    price: 0,
                    timePeriod: '00:00:00-23:59:59'
                }
            ],
            dialogVisible: false,
            detailDialogVisible: false,
            newCost: {
                costName: '',
                costType: '',
                costUnit: '',
                price: 0,
                timePeriod: ''
            },
            currentDetail: {}
        };
    },
    methods: {
        handleAddCost() {
            this.dialogVisible = true;
            this.newCost = {
                costName: '',
                costType: '',
                costUnit: '',
                price: 0,
                timePeriod: ''
            };
        },
        handleConfirmAdd() {
            this.costList.push({ ...this.newCost });
            this.dialogVisible = false;
        },
        handleViewDetail(row) {
            this.currentDetail = { ...row };
            this.detailDialogVisible = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.cost-management {
    padding: 20px;
}
</style>